import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

type Props = {
  onRetry: () => void
}

export const InsuranceError = ({ onRetry }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('safe-area-top-padding', styles.container)}>
      <div className={styles.content}>
        <div className={styles.textInfo}>
          <h1 className={clsx(styles.title, 'bold-28')}>
            {t('insurance.vzr.error.title')}
          </h1>
          <p className={clsx(styles.description, 'medium-16')}>
            {t('insurance.vzr.error.description')}
          </p>
        </div>

        <Button
          type="button"
          variant="grey"
          className={styles.button}
          onClick={onRetry}
        >
          <span className="bold-16">{t('insurance.vzr.error.try_again')}</span>
        </Button>
      </div>
    </div>
  )
}
